import {
  VehicleBodyTypesSearchRequest,
  VehicleBodyWeightClassSearchRequest,
} from '@trukt/tms-api/VehicleService';
import { createKey } from './createKey';

const keyHandler = createKey('vehicle');

export const VehicleServiceKeys = {
  key: keyHandler.key,
  searchBodyTypes: keyHandler.createMethod<VehicleBodyTypesSearchRequest>(),
  searchWeightClass: keyHandler.createMethod<VehicleBodyWeightClassSearchRequest>(),
};
